import styled from 'styled-components'

import { Image as ImageBase } from '@src/Application/Interfaces/Atoms/Image'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Tag = styled.div`
    border: 1px solid ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.color.g100};
    border-radius: 29px;
    height: 37px;
    padding: 0px 15px;
    ${(props) => props.theme.typo.bodyS}
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    svg,
    img {
        margin-right: 7px;
    }

    img {
        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(163%) contrast(107%);
    }
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    display: flex;
    flex-wrap: wrap;

    margin-bottom: 40px;

    ${Tag} {
        margin-right: 10px;
        border-color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.black)};
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.black)};
    }
`
export const Image = styled(ImageBase)`
    max-width: 16px;
    margin-right: 7px;
`
